import { useState } from "react";
import { ThumbsUp } from "react-feather";
import { Alerts, Btn, P } from "../../../../AbstractElements";

const DarkOutline = () => {
  const [active, setActive] = useState(true);
  return (
    <Alerts color="default" isOpen={active} className={`txt-success border-success outline-2x alert-dismissible fade alert-icons`}>
      <ThumbsUp />
      <P>
        <b> {"Well done! "}</b>
        {"You successfully read this important message."}
      </P>
      <Btn color="transperant" close onClick={() => setActive(false)} />
    </Alerts>
  );
};
export default DarkOutline;
